import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38f8ea44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field-container" }
const _hoisted_2 = {
  key: 0,
  class: "field-name",
  for: "input-field-text"
}
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass({
            'drop-icon-wrapper': true,
          })
}
const _hoisted_5 = { class: "list-dropdown" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "list-dropdown" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "advise" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'form-group': true,
      'input-is-invalid': _ctx.validation_message,
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass({
          'input-field': true,
          'input-not-empty': _ctx.show || _ctx.hours >= 0,
          'input-disabled': _ctx.disabled,
        }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle()))
      }, [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          type: "text",
          name: "input-field-text",
          class: _normalizeClass({
            'show-time': true,
            'not-complete': !(_ctx.hours >= 0 && _ctx.minutes >= 0),
          }),
          value: 
            _ctx.show || _ctx.hours >= 0 || _ctx.minutes >= 0
              ? (_ctx.hours >= 0 ? String(_ctx.hours).padStart(2, '0') : 'hh') +
                ':' +
                (_ctx.minutes >= 0 ? String(_ctx.minutes).padStart(2, '0') : 'mm')
              : ''
          ,
          autocomplete: "off",
          readonly: "true",
          tabindex: "-1"
        }, null, 10, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_font_awesome_icon, {
            class: "drop-icon",
            icon: ['fa', 'clock']
          })
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass({
          'dropdown-wrap': true,
          'show-dowpdown': _ctx.show,
        })
      }, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clock, (minutes, hour) => {
            return (_openBlock(), _createElementBlock("span", {
              key: hour,
              class: _normalizeClass({
              'is-selected': hour == _ctx.hours,
              'not-pickable': !minutes.find((p) => p),
            }),
              onClick: ($event: any) => (_ctx.setHours(hour))
            }, _toDisplayString(String(hour).padStart(2, "0")), 11, _hoisted_6))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clock[_ctx.hours], (pickable, minute) => {
            return (_openBlock(), _createElementBlock("span", {
              key: minute,
              class: _normalizeClass({
              'is-selected': minute == _ctx.minutes,
              'not-pickable': !pickable,
            }),
              onClick: ($event: any) => (_ctx.setMinutes(minute))
            }, _toDisplayString(String(minute).padStart(2, "0")), 11, _hoisted_8))
          }), 128))
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.validation_message)
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 0,
            icon: "exclamation-circle"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(_ctx.validation_message), 1)
    ])
  ], 2))
}